<template>
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate>
        <b-form-group :label="`${$t('form.label.title')}*`" label-for="title">
            <b-form-input
                id="title"
                ref="title"
                type="text"
                :placeholder="$t('form.placeholder.title')"
                :state="chkState('title')"
                v-model.lazy.trim="$v.form.title.$model"
                aria-describedby="titleFeedback"
                autocomplete="given-unit-measurement"
                autofocus
            />
            <b-form-invalid-feedback id="titleFeedback">
                <span v-if="!$v.form.title.required">
                    {{ $t('form.validations.required') }}
                </span>
                <span v-if="!$v.form.title.maxLength">
                    {{ $t('form.validations.maxLength', { value: '255' }) }}
                </span>
            </b-form-invalid-feedback>
        </b-form-group>
        <ButtonLoader
            class="float-right ml-1"
            type="submit"
            variant="primary"
            :disabled="$v.form.$invalid || loader"
            :loader="loader"
        >
            {{ $t('form.button.save') }}
        </ButtonLoader>
        <b-button
            class="float-right"
            variant="secondary"
            :disabled="loader"
            @click="redirectToList"
        >
            {{ $t('form.button.cancel') }}
        </b-button>
    </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import ButtonLoader from '@/views/components/button-loader'

const initialState = {
    title: '',
}

export default {
    name: 'Form',
    components: {
        ButtonLoader,
    },
    props: ['unitOfMeasurement', 'isInCollapse'],
    mixins: [validationMixin],
    data() {
        return {
            form: Object.assign({}, initialState),
            loader: false,
        }
    },
    validations: {
        form: {
            title: {
                required,
                maxLength: maxLength(255),
            },
        },
    },
    watch: {
        unitOfMeasurement(unitOfMeasurement) {
            this.form = Object.assign({}, unitOfMeasurement)
        },
    },
    computed: {
        isValid() {
            return !this.$v.form.$anyError
        },
        isDirty() {
            return this.$v.form.$anyDirty
        },
    },
    methods: {
        onSubmit() {
            if (this.validate()) {
                this.$nextTick(() => {
                    this.$emit(
                        'onSubmit',
                        this.form,
                        this.onReset,
                        this.isLoading
                    )
                })
            }
        },
        isLoading(state) {
            this.loader = state
        },
        onReset() {
            this.form = Object.assign({}, initialState)
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        chkState(val) {
            const field = this.$v.form[val]
            return !field.$dirty || !field.$invalid
        },
        validate() {
            this.$v.$touch()
            return this.isValid
        },
        redirectToList() {
            if (this.isInCollapse) {
                this.$emit('canceled', this.onReset)
            } else {
                this.$router.push({
                    path: '/v2/target/units-of-measurement/list',
                })
            }
        },
    },
}
</script>

<style scoped>
.btn.disabled {
    cursor: auto;
}
</style>
